
import ProviderDetail from "../../provider-detail";
import { useProviderSearch } from "../hooks/useProviderSearch";
import { useProviderSearchStore } from "../store/providerSearchStore";

import ModalHeader from "./Modal/ModalHeader";
import ProviderInfoContainer from "./ProviderInfoContainer";
import ProviderMapContainer from "./ProviderMapContainer";

export default function ProviderSearchContainer({ isModal, onClose }) {
  useProviderSearch();
  const { selectedProvider, openProviderDetail, setOpenProviderDetail, isProviderMapPage } = useProviderSearchStore();

  return (
    <div className="flex h-[85vh] flex-col">
      {!isProviderMapPage && <ModalHeader isModal={isModal} onClose={onClose} />}
      <div className="flex w-full flex-1 flex-row gap-4 px-4 py-2 items-stretch">
        <ProviderInfoContainer />
        <div className="flex-1 h-full w-full">
          <ProviderMapContainer />
        </div>
      </div>

      {selectedProvider && (
        <ProviderDetail
          providerDetail={selectedProvider}
          open={openProviderDetail}
          setOpen={setOpenProviderDetail}
        />
      )}
    </div>
  );
}
